(function() {
	var SvgChartGlobal = MST;
	var SvgChartDrawUtil = MST.SvgChartDrawUtil;
	var SvgChartCache = MST.SvgChartCache;
	
	var SvgChartProjector = function () {
	};
	
	SvgChartProjector.prototype.updateDataMinMax = function(technicalList, mapping)
	{
		// console.log("========updateDataMinMax start ===========");
		var min0 = null;
		var max0 = null;
		var min1 = null;
		var max1 = null;
	
		var data;
		var name;
	
		for(var t = 0; t < technicalList.length; t++) {
			var min = null;
			var max = null;
	
			var technical = technicalList[t];
			if (technical.type == "dummy") continue;
	
			var start = Math.max(0, mapping.dataStartIndex);
			var end = (mapping.dataStartIndex + mapping.dataLength);
			
			if (technical.type == "sub") {
				start = 0;
				end = technical.view.chart.mainTechnical.data.length;
			}
	
			if (technical.name == "fundLine" || (mapping.benchmark && technical.code != null && technical.code.length == 8)) {
				var data = technical.data;
				if (technical.name == "fundLine") {
					data = technical.view.chart.mainTechnical.data;
				}
	
				var dividendSum = 0;
	
				for (var i = start; i < end; i++){
					if (data[i] == null || data[i].close == null) continue;
	
					if (data[i].dividend_bak != null){
						dividendSum += data[i].dividend_bak;
					}
	
					if (technical.name == "fundLine") {
						data[i].dividend = data[i].close_bak + dividendSum;
					} else {
						data[i].close = data[i].close_bak + dividendSum;
					}
				}
			} else if (t == 0 && technical.view.technicalList.length > 1 && mapping != technical.view.chart.scrollView.scrollMapping) {
				var data = technical.view.chart.mainTechnical.data;
				for (var i = start; i < end; i++) {
					data[i].close = data[i].close_bak;
				}
			}
	
			if (mapping.benchmark) {
				if (t > 0 && technical.benchmarkShow == false) {
					continue;
				}
			}
	
			switch(technical.name) {
			case "candle":
				data = technical.data;
				name = "close";
				for(var i = mapping.dataStartIndex; i < (mapping.dataStartIndex + mapping.dataLength); i++) {
					var v = data[i];
	
					if(v == null || v == "") continue;
	
					var vh = Number(v.high);
					var vl = Number(v.low);
	
					if(v != null) {
						if(vl != 0 && (min == null || min > vl)) {
							min = vl;
						}
	
						if(vh != 0 && (max == null || max < vh)) {
							max = vh;
						}
					}
				}
	
				break;
	
			case "line":
			case "mountain":
			case "intraday":
			case "twoDays":
				data = technical.data;
				name = "close";
				for(var i = mapping.dataStartIndex; i < (mapping.dataStartIndex + mapping.dataLength); i++) {
					var v = data[i];
	
					if(v == null || v.close == null) continue;
	
					var vc = Number(v.close);
	
					if(v != null) {
						if(vc != 0 && (min == null || min > vc)) {
							min = vc;
						}
	
						if(vc != 0 && (max == null || max < vc)) {
							max = vc;
						}
					}
				}
	
				break;
	
	
			default:
	
				if(technical.dataLoadType == MST.SvgChartTechnical.DATA_LOAD_TYPE_WITH_MAIN) {
					data = technical.view.chart.mainTechnical.data;
					name = technical.dataLoadName;
	
					for(var i = start; i < end; i++) {
						if(data[i] == null) continue;
						if(name == "dividend" && data[i].close == null) continue;
						// if(name == "dividend") continue;
	
						v = data[i][name];
	
						if(v == null || v == "") continue;
	
						v = Number(v);
	
						if(v != null) {
							if(min == null || min > v) {
								min = v;
							}
							
							if(max == null || max < v) {
								max = v;
							}
						}
					}
				} else {
					data = technical.data;
					if (data != null && (technical.type == "sub" || !mapping.benchmark)) {
						for (var j = 0; j < technical.labels.length; j++) {
							for (var i = start; i < end; i++) {
								var v = data[technical.labels[j].data][i];
								if (v != null) {
									if (min == null || min > v) {
										min = v;
									}
									if (max == null || max < v) {
										max = v;
									}
								}
							}
						}
					}
				}
	
				break;
			}
	
	
			if (technical == technical.view.chart.mainTechnical && technical.view.chart.drawLastClose()) {
				if (technical.lastCloseStartIndex + 1 < (mapping.dataStartIndex + mapping.dataLength) 
					&& technical.lastCloseValue != null) {
					v = technical.lastCloseValue;
					if (min == null || min > v) {
						min = v;
					}
					if (max == null || max < v) {
						max = v;
					}
				}
				if (technical.lastlastCloseStartIndex + 1 < (mapping.dataStartIndex + mapping.dataLength) 
					&& technical.lastlastCloseValue != null) {
					v = technical.lastlastCloseValue;
					if (min == null || min > v) {
						min = v;
					}
					if (max == null || max < v) {
						max = v;
					}
				}
			}
			if (technical.name == "volume") {
				min = 0;
				if (max <= 0) max = 10;
			}
	
			if (mapping.benchmark == true) {
				if(data[mapping.dataStartIndex] != null && data[mapping.dataStartIndex][name] > 0){
					min = (min / data[mapping.dataStartIndex][name] - 1) * 100;
					max = (max / data[mapping.dataStartIndex][name] - 1) * 100;
				}
				else if(data[mapping.dataStartIndex] != null) {
					// process two benchmar data has different data length
					for(var k = mapping.dataStartIndex; k < (mapping.dataStartIndex + mapping.dataLength); k++){
						if(data[k] && data[k][name]) break;
					}
					if(k != (mapping.dataStartIndex + mapping.dataLength)){
						min = (min / data[k][name] - 1) * 100;
						max = (max / data[k][name] - 1) * 100;
					}else{
						min = min0;
						max = max0;
					}
				}
	
			}
	
			if (min > 0 && max < min * (1 + SvgChartGlobal.MIN_HEIGHT)) {
				max = min * (1 + SvgChartGlobal.MIN_HEIGHT);
			}
	
			if (technical.vAxis == 1 && min != null  && max != null) {
				if (min1 == null || min1 > min) {
					min1 = min;
				}
	
				if (max1 == null || max1 < max) {
					max1 = max;
				}
			} else if (min != null  && max != null) {
				if (min0 == null || min0 > min) {
					min0 = min;
				}
	
				if (max0 == null || max0 < max) {
					max0 = max;
				}
			}
		}
	
		if (min0 != null && max0 != null) {
			mapping.setDataMinMax(min0, max0);
		} else {
			mapping.setDataMinMax(0, 0);
		}
	
		if (min1 != null && max1 != null) {
			mapping.setDataMinMax1(min1, max1);
		} else {
			mapping.setDataMinMax1(min0, max0);
		}
	};
	
	SvgChartProjector.prototype.project = function(context, technicalList, mapping) {
		for (var t = 0; t < technicalList.length; t++) {
			var technical = technicalList[t];
	
			if (technical.type == "dummy") continue;
	
			var name = technical.name;
			var period = technical.view.chart.period;
			if (mapping.benchmark) {
				name = "line";
			}
	
			if (mapping.benchmark) {
				if (t > 0 && technical.benchmarkShow == false) {
					continue;
				}
			}
	
	
			switch(name) {
				case "candle":
					this.projectCandle(context, technical, mapping);
					break;
	
				case "Ichimoku":
					if (!mapping.benchmark) {
						this.projectIchimoku(context, technical, mapping);
					}
					break;
					
				case "LinearTrend":
					if (!mapping.benchmark) {
						this.projectLinearTrend(context, technical, mapping);
					}
					break;
	
				case "MACD":
				case "BollingerBand":
				case "SRV":
					this.projectLines(context, technical, mapping);
					break;
				case "MA18":
				case "MA38":
				case "MA90":
				case "MA":
					if (technical.type == "sub" || !mapping.benchmark) {
						this.projectLines(context, technical, mapping);
					}
					break;
	
				case "intraday":
					this.projectIntraday(context, technical, mapping);
					break;
	
				case "twoDays":
				case "line":
				case "mountain":
				case "portfolioLine":
				case "portfolioMountain":
					this.projectLine(context, technical, mapping);
					break;
				case "fundLine":
					this.projectLine(context, technical, mapping);
					break;
	
				case "volume":
					this.projectVolume(context, technical, mapping);
					break;
	
				default:
					 this.projectLines(context, technical, mapping);
			}
		}
	
		var mainTechnical = technicalList[0].view.chart.mainTechnical;
	
		if (technicalList[0] == mainTechnical && mainTechnical.view.chart.drawLastClose()) {
			this.projectLastClose(context, mainTechnical, mapping);
		}
	};
	
	SvgChartProjector.prototype.projectLastClose = function(context, technical, mapping) {
		// console.log("======projectLastClose======");
		var start = Math.max(0, mapping.dataStartIndex);
		var end = mapping.dataStartIndex + mapping.dataLength;
		var lastCloseStartIndex = technical.lastCloseStartIndex;
		if (lastCloseStartIndex + 1 >= end) return;
	
		var dataColor = technical.view.chart.pickColors;
	
	
	
		var v = technical.lastCloseValue;
	
		if (v == null) return;
	
		var x = mapping.transformIndex(lastCloseStartIndex) + 0.5;
		var y = mapping.transformValue(v, technical.vAxis) + 0.5;
		var x1 = mapping.transformIndex(end) + 0.5;
	
		SvgChartDrawUtil.line(context, x, y, x1, y, SvgChartGlobal.COLOR_LAST_CLOSE, "5,5");
	
		var v = technical.lastlastCloseValue;
	
		if (v == null) return;
	
		var x0 = mapping.transformIndex(technical.lastlastCloseStartIndex) + 0.5;
		var y = mapping.transformValue(v, technical.vAxis) + 0.5;
	
		SvgChartDrawUtil.line(context, x0, y, x, y, SvgChartGlobal.COLOR_LAST_CLOSE, "5,5");
	};
	
	SvgChartProjector.prototype.projectPick= function(context, technical, mapping) {
		// console.log("======projectPick======");
		var start = Math.max(0, mapping.dataStartIndex);
		var end = mapping.dataStartIndex + mapping.dataLength;
		var dataColor = technical.view.chart.pickColors;
	
		var candleData = technical.view.chart.mainTechnical.data;
		var data = technical.data;
	
		for(var i = start; i < end; i++) {
			if (data[i] == null) continue;
	
			var v = candleData[i]["close"];
	
			if (v == null) continue;
	
			if (mapping.benchmark == true) {
				v = (v / candleData[start]["close"] - 1) * 100;
			}
	
			var x = mapping.transformIndex(i) + 0.5;
			var y = mapping.transformValue(v, technical.vAxis) + 0.5;
	
			if (data[i].recommendation > 0) {
				SvgChartDrawUtil.drawPoint(context, x, y, dataColor[0], SvgChartGlobal.PICK_WIDTH);
			} else if (data[i].recommendation <= 0) {
				SvgChartDrawUtil.drawPoint(context, x, y, dataColor[1], SvgChartGlobal.PICK_WIDTH);
			}
		}
	
	};
	
	SvgChartProjector.prototype.projectIchimoku = function(context, technical, mapping) {
		// console.log("======projectIchimoku======");
		var start = Math.max(0, mapping.dataStartIndex);
		var end = mapping.dataStartIndex + mapping.dataLength;
	
		var data = technical.data;
	
		context.lineWidth = 1;
	
		var pTransit = new Array();
		var pBase = new Array();
		var pPrecede1 = new Array();
		var pPrecede2 = new Array();
		var pLater1 = new Array();
		var cloud = new Array();
	
		for(var i = start; i < end; i++) {
			var vTransit = data["resultTransit"][i];
			var vBase = data["resultBase"][i];
			var vPrecede1 = data["resultPrecede1"][i];
			var vPrecede2 = data["resultPrecede2"][i];
			var vLater1 = data["resultLater1"][i];
	
			var x = mapping.transformIndex(i) + 0.5;
	
			if(vTransit != null && vTransit != undefined) {
				var yTransit = mapping.transformValue(vTransit) + 0.5;
				pTransit.push({x : x, y : yTransit});
			}
			if(vBase != null && vBase != undefined) {
				var yBase = mapping.transformValue(vBase) + 0.5;
				pBase.push({x : x, y : yBase});
			}
			if(vPrecede1 != null && vPrecede1 != undefined) {
				var yPrecede1 = mapping.transformValue(vPrecede1) + 0.5;
				pPrecede1.push({x : x, y : yPrecede1});
			}
			if(vPrecede2 != null && vPrecede2 != undefined) {
				var yPrecede2 = mapping.transformValue(vPrecede2) + 0.5;
				pPrecede2.push({x : x, y : yPrecede2});
				cloud.push({x : x, y : yPrecede2});
			}
			if(vLater1 != null && vLater1 != undefined) {
				var yLater1 = mapping.transformValue(vLater1) + 0.5;
				pLater1.push({x : x, y : yLater1});
			}
	
			if(vPrecede1 != null && vPrecede1 != undefined && vPrecede2 != null && vPrecede2 != undefined) {
				var yPrecede1 = mapping.transformValue(vPrecede1) + 0.5;
				var yPrecede2 = mapping.transformValue(vPrecede2) + 0.5;
				pPrecede2.push({x : x, y : yPrecede2});
			}
		}
		for(var i = end - 1; i >= start; i--) {
			var vPrecede1 = data["resultPrecede1"][i];
			var vPrecede2 = data["resultPrecede2"][i];
			if(vPrecede2 != null && vPrecede2 != undefined) {
				var x = mapping.transformIndex(i) + 0.5;
				var yPrecede1 = mapping.transformValue(vPrecede1) + 0.5;
				cloud.push({x : x, y : yPrecede1});
			}
		}
	
		SvgChartDrawUtil.pathFill(context, cloud, 1, "#FFFFFF", "#AAAAAA", 0.5);
		SvgChartDrawUtil.path(context, pTransit, technical.lineWidth[0], technical.dataColor[0]);
		SvgChartDrawUtil.path(context, pBase, technical.lineWidth[1], technical.dataColor[1]);
		SvgChartDrawUtil.path(context, pPrecede1, technical.lineWidth[2], technical.dataColor[2]);
		SvgChartDrawUtil.path(context, pPrecede2, technical.lineWidth[3], technical.dataColor[3]);
		SvgChartDrawUtil.path(context, pLater1, technical.lineWidth[4], technical.dataColor[4]);
	};
	
	SvgChartProjector.prototype.projectLinearTrend = function(context, technical, mapping)
	{
		var start = Math.max(0, mapping.dataStartIndex);
		var end = mapping.dataStartIndex + mapping.dataLength;
	
		var data = technical.data;
	
		for (var j = 0; j < technical.labels.length; j++) {
			var p = new Array();
	
			for (var i = start; i < end; i++) {
				var v = data[technical.labels[j].data][i];
	
				if (v == null)
					continue;
	
				var x = mapping.transformIndex(i) + 0.5;
				var y = mapping.transformValue(v, technical.vAxis) + 0.5;
	
				p.push({x : x, y : y});
			}
	
			if (p.length > 1) {
				var x0 = p[0].x;
				var y0 = p[0].y;
				var x1 = p[p.length - 1].x;
				var y1 = p[p.length - 1].y;
				SvgChartDrawUtil.line(context, x0, y0, x1, y1, technical.dataColor[j]);
			}
		}
	};
	
	SvgChartProjector.prototype.projectVolume = function(context, technical, mapping) {
		var start = Math.max(0, mapping.dataStartIndex);
		var end = mapping.dataStartIndex + mapping.dataLength;
	
		var data = technical.view.chart.mainTechnical.data;
	
		// var candleWidth = Math.max(0.5, Math.round((mapping.getUnitWidth() - 2) / 2) - 0.5);
		var candleWidth = Math.max(0.5, Math.floor(mapping.getUnitWidth() * 0.35) - 0.5);
	
		var y0 = mapping.drawAreaHeight - mapping.paddingBottom - 0.5;
		var fillStyle;
	
		let elements = [];
		for (var i = start; i < end; i++) {
			if (data[i] == null || data[i] == undefined)
				continue;
			if (data[i].volume == null || data[i].volume == undefined)
				continue;
	
			var v = Number(data[i].volume);
			if (v <= 0)
				continue;
	
				fillStyle = technical.dataColor[0];
	
			var x = mapping.transformIndex(i);
			var y = mapping.transformValue(v) - 0.5;
	
			var rect = SvgChartDrawUtil.fillRect(context, x - candleWidth, y, candleWidth * 2, y0 - y, fillStyle, fillStyle);
			elements[i] = rect;
		}
		technical.elements = elements;
	
		var x0, x1;
	
		x0 = mapping.paddingLeft - SvgChartGlobal.LAYOUT_PANEL_CONTENT_PADDING + 0.5;
		x1 = mapping.drawAreaWidth - SvgChartGlobal.LAYOUT_PANEL_CONTENT_PADDING + 0.5;
	
		SvgChartDrawUtil.line(context, x0, y0, x1, y0, SvgChartGlobal.COLOR_PANDEL_GRID);
	};
	
	// draw candles
	SvgChartProjector.prototype.projectCandle = function(context, technical, mapping)
	{
		var start = Math.max(0, mapping.dataStartIndex);
		var end = mapping.dataStartIndex + mapping.dataLength;
	
		// var candleWidth = Math.max(0, Math.round((mapping.getUnitWidth() - 2) / 2));
		var candleWidth = Math.floor(mapping.getUnitWidth() * 0.45);
	
		context.lineWidth = 1;
	//	var dataColor = ["#000000", "#f17b00", "#000000", "#538f1d"];
		var dataColor = ["#000000", "#ffffff", "#000000", "#000000"];
	
		for(var i = start; i < end; i++) {
			if (technical.data[i].close == null) continue;
	
			var vo = Number(technical.data[i].open);
			var vh = Number(technical.data[i].high);
			var vl = Number(technical.data[i].low);
			var vc = Number(technical.data[i].close);
	
			var x = mapping.transformIndex(i) + 0.5;
			var yo = mapping.transformValue(vo) + 0.5;
			var yh = mapping.transformValue(vh) + 0.5;
			var yl = mapping.transformValue(vl) + 0.5;
			var yc = mapping.transformValue(vc) + 0.5;
	
			if(vc > vo) {
	
				SvgChartDrawUtil.line(context, x, yh, x, yl, dataColor[0]);
	
				if (candleWidth > 1) {
					SvgChartDrawUtil.fillRect(context, x - candleWidth, yc, candleWidth * 2, yo - yc, dataColor[0], dataColor[1]);
				}
			}
			else {
	
				SvgChartDrawUtil.line(context, x, yh, x, yl, dataColor[2]);
	
				if (candleWidth > 1) {
					SvgChartDrawUtil.fillRect(context, x - candleWidth, yo, candleWidth * 2, yc - yo, dataColor[2], dataColor[3]);
				}
			}
		}
	};
	
	SvgChartProjector.prototype.projectLines = function(context, technical, mapping)
	{
		var start = Math.max(0, mapping.dataStartIndex);
		var end = mapping.dataStartIndex + mapping.dataLength;
	
		var data = technical.data;
		if (technical.labels) {
			for (var j = 0; j < technical.labels.length; j++) {
				var pointCount = 0;
				var p = new Array();
		
				for (var i = start; i < end; i++) {
					var v = data[technical.labels[j].data][i];
		
					if (v == null)
						continue;
		
					pointCount++;
		
					var x = mapping.transformIndex(i) + 0.5;
					var y = mapping.transformValue(v, technical.vAxis) + 0.5;
		
					p.push({x : x, y : y});
				}
		
				if (pointCount > 1) {
					SvgChartDrawUtil.path(context, p, technical.lineWidth[j], technical.dataColor[j]);
				}
			}
		}
	};
	
	// draw line chart
	SvgChartProjector.prototype.projectLine = function(context, technical, mapping)
	{
	
		var start = Math.max(0, mapping.dataStartIndex);
		var end = mapping.dataStartIndex + mapping.dataLength;
	
		var data, name;
	
		if(technical.dataLoadType == MST.SvgChartTechnical.DATA_LOAD_TYPE_WITH_MAIN) {
			data = technical.view.chart.mainTechnical.data;
			name = technical.dataLoadName;
		}
		else {
			data = technical.data;
			name = technical.dataLoadName;
		}
	
		var pointCount = 0;
		var p = new Array();
		var cloud = new Array();
	
		if(technical.view.chart.showFund && mapping.benchmark == true && technical == technical.view.chart.mainTechnical){
			return;
		}
	
		// process tow benchmar data has different data length
		for(var j = start; j < end; j++){
			if(data[j] && data[j][name]){
	//			baseValue = data[j][name];
				break;
			}
		}
	
		for(var i = start; i < end; i++) {
			if (data[i] == null) continue;
			var v = data[i][name];
	
			if (v == null || v == undefined) continue;
			if(name == "dividend" && data[i]["close"] == null) continue;
	
			if (mapping.benchmark == true) {			
				v = (v / data[j][name] - 1) * 100;
			}
	
			pointCount++;
	
			var x = mapping.transformIndex(i) + 0.5;
			var y = mapping.transformValue(v, technical.vAxis) + 0.5;
	
			p.push({x : x, y : y});
			cloud.push({x : x, y : y});
		}
	
		if(pointCount > 1) {
			if ((technical.name == "mountain" || technical.name == "portfolioMountain" || technical.name == "twoDays") && mapping.benchmark == false) {
				v = mapping.vAxisValues[0].value;
				y = mapping.transformValue(v, technical.vAxis) + 0.5;
	
				// x = mapping.transformIndex(end - 1) + 0.5;
				x = cloud[cloud.length - 1].x;
				cloud.push({x : x, y : y});
	
	//			x = mapping.transformIndex(start) + 0.5;
				cloud.push({x : cloud[0].x, y : y});
				// console.log(cloud);
	
				let fillColor = "#3A93D4";
	
				SvgChartDrawUtil.pathFill(context, cloud, 0, null, fillColor, 0.5);
			}
	
			var lineWidth = technical.lineWidth[0];
	
			var dataColor = technical.dataColor[0];
	
			SvgChartDrawUtil.path(context, p, lineWidth, dataColor);
		}
	};
	
	// draw intraday chart
	SvgChartProjector.prototype.projectIntraday = function(context, technical, mapping)
	{
		var start = Math.max(0, mapping.dataStartIndex);
		var end = mapping.dataStartIndex + mapping.dataLength;
	
		var data, name;
	
		data = technical.data;
		name = "close";
	
		if (data.length == 0) {
			return;
		}
	
		var pointCount = 0;
		var fu = new Array();
		var fd = new Array();
		var pu = new Array();
		var pd = new Array();
		var pus = new Array();
		var pds = new Array();
	
	
		v0 = technical.lastCloseValue;
	
		y0 = mapping.transformValue(v0, technical.vAxis) + 0.5;
		x0 = mapping.transformIndex(start) + 0.5;
		x1 = mapping.transformIndex(end - 1) + 0.5;
	
		for(var i = start; i < end; i++) {
	
			if (data[i] == null) {
				continue;
			}
	
			var v = data[i][name];
	
			if (mapping.benchmark == true) {
				v = (v / data[start][name] - 1) * 100;
			}
	
			if(v == null) continue;
	
			pointCount++;
	
			var x = mapping.transformIndex(i) + 0.5;
			var y = mapping.transformValue(v, technical.vAxis) + 0.5;
	
			var color0 = "#0f9d49";
			var color1 = "#e44326";
	
			var fillColor0 = "90-#d8fdeb-#279f65";
			var fillColor1 = "90-#ee7d62-#fae5e1";
	
			var fillOpacity = 0.3;
	
	
	
	
			if (y > y0) {
				if (pd.length > 0) {
					var x_last = pd[pd.length - 1].x;
					var y_last = pd[pd.length - 1].y;
					var xx = (x_last * (y - y0) + x * (y0 - y_last)) / (y - y_last);
					pd.push({x : xx, y : y0});
					pu.push({x : xx, y : y0});
					pds.push(pd);
					pd = new Array();
				}
				fu.push({x : x, y : y});
				pu.push({x : x, y : y});
	
				fd.push({x : x, y : y0});
			} else if (y < y0) {
				if (pu.length > 0) {
					var x_last = pu[pu.length - 1].x;
					var y_last = pu[pu.length - 1].y;
					var xx = (x_last * (y - y0) + x * (y0 - y_last)) / (y - y_last);
					pd.push({x : xx, y : y0});
					pu.push({x : xx, y : y0});
					pus.push(pu);
					pu = new Array();
				}
				fd.push({x : x, y : y});
				pd.push({x : x, y : y});
	
				fu.push({x : x, y : y0});
			} else {
				if (pd.length > 0) {
					pd.push({x : x, y : y});
					pds.push(pd);
					pd = new Array();
				}
				if (pu.length > 0) {
					pu.push({x : x, y : y});
					pus.push(pu);
					pu = new Array();
				}
	
				pu.push({x : x, y : y});
				pd.push({x : x, y : y});
	
				fu.push({x : x, y : y0});
				fd.push({x : x, y : y0});
			}
	
		}
	
		if (fd.length > 0) {
			fd.push({x : fd[fd.length - 1].x, y : y0});
			fd.push({x : fd[0].x, y : y0});
			SvgChartDrawUtil.pathFill(context, fd, 0, null, fillColor0, fillOpacity);
		}
		if (fu.length > 0) {
			fu.push({x : fu[fu.length - 1].x, y : y0});
			fu.push({x : fu[0].x, y : y0});
			SvgChartDrawUtil.pathFill(context, fu, 0, null, fillColor1, fillOpacity);
		}
	
		for (var i = 0; i < pds.length; i++) {
			SvgChartDrawUtil.path(context, pds[i], 2, color0);
		};
		for (var i = 0; i < pus.length; i++) {
			SvgChartDrawUtil.path(context, pus[i], 2, color1);
		};
	
		if (pd.length > 1) {
			SvgChartDrawUtil.path(context, pd, 2, color0);
		} else if (pd.length == 1) {
			SvgChartDrawUtil.drawPoint(context, pd[0].x, pd[0].y, color0, 3);
		}
		if (pu.length > 1) {
			SvgChartDrawUtil.path(context, pu, 2, color1);
		} else if (pu.length == 1) {
			SvgChartDrawUtil.drawPoint(context, pu[0].x, pu[0].y, color1, 3);
		}
		// SvgChartDrawUtil.line(context, x0, y0, x1, y0, "#808080");
	};
	
	
	
	// draw axis
	SvgChartProjector.prototype.projectAxis = function(context, mapping, index)
	{
		var x0 = mapping.paddingLeft - SvgChartGlobal.LAYOUT_PANEL_CONTENT_PADDING + 0.5;
		var x1 = mapping.drawAreaWidth - SvgChartGlobal.LAYOUT_PANEL_CONTENT_PADDING + 0.5;
		var y0 = mapping.paddingTop + 0.5;
		var y1 = mapping.drawAreaHeight - mapping.paddingBottom + 0.5;
	
		var x2 = x1 + 4.5;
		var y2 = mapping.drawAreaHeight - SvgChartGlobal.LAYOUT_PANEL_FRAME_PADDING + 0.5;

		for(var i = 0; i < mapping.hAxisValues.length; i++) {
			var x = mapping.transformIndex(mapping.hAxisValues[i].value) + 0.5;
			var y;
	
			 SvgChartDrawUtil.line(context, x, y0, x, y1, SvgChartGlobal.COLOR_PANDEL_GRID);
	
			var text;
			if (index == 0) {
				y = y2 - 5;
				text = SvgChartDrawUtil.fillText(context, x, y, mapping.hAxisValues[i].label, SvgChartGlobal.COLOR_PANDEL_AXIS_TEXT, "center");
				SvgChartDrawUtil.line(context, x, y1, x, y1 + 5, mapping.panel.gridColor);
			} else if (index < 0) {
				y = y1 - 4;
				SvgChartDrawUtil.line(context, x, mapping.paddingTop + 0.5, x, y1, mapping.panel.gridColor);
				text = SvgChartDrawUtil.fillText(context, x, y, mapping.hAxisValues[i].label, SvgChartGlobal.COLOR_PANDEL_AXIS_TEXT, "center");
			}
		}
	
		var xt = SvgChartGlobal.LAYOUT_PANEL_FRAME_PADDING + 0.5;
	
		if (mapping.vAxisValues != null) {
			for (var i = 0; i < mapping.vAxisValues.length; i++) {
				var y = mapping.transformValue(mapping.vAxisValues[i].value) + 0.5;
					SvgChartDrawUtil.line(context, x0, y, x1, y, mapping.panel.gridColor);
			}
		}
	};
	
	// draw axis text
	SvgChartProjector.prototype.projectAxisText = function(context, mapping, index)
	{
		var xl = SvgChartGlobal.LAYOUT_PANEL_FRAME_PADDING + 0.5;
		var xr = mapping.drawAreaWidth - SvgChartGlobal.LAYOUT_PANEL_CONTENT_PADDING + 0.5;
	
		if (mapping.vAxisValues != null) {
			for (var i = 0; i < mapping.vAxisValues.length; i++) {
				if (index == 0 && i == mapping.vAxisValues.length - 1) continue;
				
				var y = mapping.transformValue(mapping.vAxisValues[i].value) + 0.5;
				var text = SvgChartDrawUtil.fillText(context, xr, y - 4, mapping.vAxisValues[i].label, SvgChartGlobal.COLOR_PANDEL_AXIS_TEXT, "right");
			}
		}
	};
	
	// draw scroll bar
	SvgChartProjector.prototype.projectScroll = function(context, technicalList, mapping)
	{
		for(var t = 0; t < technicalList.length; t++) {
			var technical = technicalList[t];
	
			this.projectScrollMountain(context, technical, mapping);
		}
	};
	
	// draw scroll area
	SvgChartProjector.prototype.projectAreaScroll = function(context, technicalList, mapping, mainMapping)
	{
		for(var t = 0; t < technicalList.length; t++) {
			var technical = technicalList[t];
	
			this.projectScrollMountainArea(context, technical, mapping, mainMapping);
		}
	};
	
	SvgChartProjector.prototype.projectScrollMountain = function(context, technical, mapping)
	{
	
		var start = Math.max(0, mapping.dataStartIndex);
		var end = mapping.dataStartIndex + mapping.dataLength;
	
		var p = new Array();
		var cloud = new Array();
	
		for(var i = start; i < end; i++) {
			var v = technical.data[i].close;
			if (v == null) continue;
	
			var x = mapping.transformIndex(i) + 0.5;
			var y = mapping.transformValue(v) + 0.5;
	
			p.push({x : x, y : y});
			cloud.push({x : x, y : y});
		}
	
		if(p.length > 1) {
			SvgChartDrawUtil.path(context, p, 1, SvgChartGlobal.COLOR_SCROLL_LINE);
	
			y = mapping.drawAreaHeight - mapping.paddingBottom + 0.5;
	
			// x = mapping.transformIndex(end - 1) + 0.5;
			x = p[p.length - 1].x + 0.5;
			cloud.push({x : x, y : y});
	
			x = mapping.transformIndex(start) + 0.5;
			cloud.push({x : x, y : y});
			SvgChartDrawUtil.pathFill(context, cloud, 0, null, SvgChartGlobal.COLOR_SCROLL_FILL, 0.7);
	
	
			var x0 = 0.5;
			var x1 = mapping.drawAreaWidth - 0.5;
			var y1 = mapping.drawAreaHeight - mapping.paddingBottom + 0.5;
			var h = mapping.drawAreaHeight - 0.5 - y1;
			// SvgChartDrawUtil.fillRect(context, x0, y1, x1 - x0, h, null, SvgChartGlobal.COLOR_SCROLL_BKGND);
			SvgChartDrawUtil.line(context, x0, y1, x1, y1, SvgChartGlobal.COLOR_PANDEL_FRAME);
		}
	};
	
	SvgChartProjector.prototype.projectScrollMountainArea = function(context, technical, mapping, mainMapping)
	{
		// SvgChartDrawUtil.clear(context);
		var start = Math.max(0, mapping.dataStartIndex);
		var end = mapping.dataStartIndex + mapping.dataLength;
	
		var areaStart = Math.max(0, mainMapping.dataStartIndex);
		var areaEnd = mainMapping.dataStartIndex + mainMapping.dataLength - 1;
	
		var p = new Array();
		var cloudArea = new Array();
		var cloudLeft = new Array();
		var cloudRight = new Array();
	
		for(var i = start; i < end; i++) {
			var v = technical.data[i].close;
			if (v == null) continue;
	
			var x = mapping.transformIndex(i) + 0.5;
			var y = mapping.transformValue(v) + 0.5;
	
			if (i < areaStart){
				cloudLeft.push({x : x, y : y});
			}
			else if (i == areaStart){
				cloudLeft.push({x : x, y : y});
				p.push({x : x, y : y});
				cloudArea.push({x : x, y : y});
			}
			else if (i > areaStart && i < areaEnd){
				p.push({x : x, y : y});
				cloudArea.push({x : x, y : y});
			}
			else if (i == areaEnd){
				p.push({x : x, y : y});
				cloudArea.push({x : x, y : y});
				cloudRight.push({x : x, y : y});
			}
			else if (i > areaEnd){
				cloudRight.push({x : x, y : y});
			}
		
		}
	
		if(p.length > 1) {
			let fillColor = "#1B78BF";
			var line = SvgChartDrawUtil.path(context, p, 1, SvgChartGlobal.COLOR_SCROLL_AREA_LINE);
			y = mapping.drawAreaHeight - mapping.paddingBottom + 0.5;
			x = p[p.length - 1].x;
			cloudArea.push({x : x, y : y});
	
			x = p[0].x;
			cloudArea.push({x : x, y : y});
			SvgChartDrawUtil.pathFill(context, cloudArea, 0, null, fillColor, 0.2);
		}
		if(cloudLeft.length > 0){
			y = mapping.drawAreaHeight - mapping.paddingBottom + 0.5;
			x = cloudLeft[cloudLeft.length - 1].x;
			cloudLeft.push({x : x, y : y});
			x = cloudLeft[0].x;
			cloudLeft.push({x : x, y : y});
	
			SvgChartDrawUtil.pathFill(context, cloudLeft, 0, null, SvgChartGlobal.COLOR_SCROLL_AREA_FILL, 0.7);
		}
		if(cloudRight.length > 0){
			y = mapping.drawAreaHeight - mapping.paddingBottom + 0.5;
			x = cloudRight[cloudRight.length - 1].x;
			cloudRight.push({x : x, y : y});
			x = cloudRight[0].x;
			cloudRight.push({x : x, y : y});
	
			SvgChartDrawUtil.pathFill(context, cloudRight, 0, null, SvgChartGlobal.COLOR_SCROLL_AREA_FILL, 0.7);
		}
	};
	
	MST.SvgChartProjector = SvgChartProjector;
}());
